import { Stack } from '@ff-it/ui';
import { useEntity } from 'components';
import { RenderSummaryCellProps } from 'components/DataGrid';
import { MoneyCell } from 'components/MoneyCell';
import { BlockDetails } from 'modules/campaign/block/types';
import { Budget } from 'modules/campaign/plan/Budget';
import { GridSummaryRow, RowOrGroup } from 'modules/campaign/plan/types';
import { ReactNode } from 'react';
import { parseBig } from 'utilities';

export function ViewSummaryBudget({
  row: {
    summary: { budgeted },
  },
}: RenderSummaryCellProps<GridSummaryRow, RowOrGroup>): ReactNode {
  const { item } = useEntity<BlockDetails>();
  const budget = parseBig(item.budget);
  return (
    <Stack direction="horizontal" align="center">
      {budget && <Budget budget={budget} amount={budgeted} details />}
      <MoneyCell width="full" textAlign="right" value={budgeted} data-testid="amount" />
    </Stack>
  );
}
